import React from 'react';
import classes from './PageLoading.module.scss';

const PageLoading = () => {
    return (
        <div className={classes.loading}>
            <span>S</span>
            {/* <span>P</span>
            <span>A</span>
            <span>R</span>
            <span>T</span>
            <span>M</span>
            <span>A</span>
            <span>N</span> */}
        </div>
    );
};

export default PageLoading;
